var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoFingerMove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "290 145 625 650",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Gesto de rolagem multidirecional") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\xCDcone verde com uma m\xE3o de dois dedos e quatro setas direcionais no canto superior esquerdo.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#269F59"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(424 284) scale(1.35) translate(-424 -284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424 190 459 225h-22v35h-26v-35h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 378 389 343h22v-35h26v35h22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 284 367 249v22h35v26h-35v22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 284 481 319v-22h-35v-26h35v-22z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528 599l5-254c1-25 15-40 35-40 20 0 32 15 32 40v148c0 8 4 13 8 13 5 0 7-5 7-13V345c0-25 13-40 33-40 20 0 32 15 33 40l5 156c17-1 34 4 49 14l36 25c16 11 23 28 21 47l-14 140c-3 31-21 49-51 49H586c-27 0-45-10-62-31L412 603c-10-13-7-28 7-39 19-15 41-17 60-9 14 6 29 18 49 44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFingerMove);
export default __webpack_public_path__ + "static/media/two-finger-move.378a033cc30b0900c0fe31d2ef155f35.svg";
export { ForwardRef as ReactComponent };